import { render, staticRenderFns } from "./VProjectView.vue?vue&type=template&id=b38cbf54&"
import script from "./VProjectView.vue?vue&type=script&lang=js&"
export * from "./VProjectView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports